import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./PaidUserDashboard.css";

const PaidUserDashboard = () => {
  const [user, setUser] = useState(null);
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = localStorage.getItem("paidUser");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setUser(parsedUser);

      axios
        .get(`${process.env.REACT_APP_API_URL}/api/user/account?email=${parsedUser.email}`)
        .then((res) => {
          setUser((prev) => ({ ...prev, plan: res.data.plan }));
        })
        .catch((err) => console.error("❌ Failed to fetch account info:", err));
    }

    axios
      .get(`${process.env.REACT_APP_API_URL}/api/videos`)
      .then((res) => {
        console.log("✅ Fetched videos:", res.data);
        setVideos(res.data.videos || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error("❌ Failed to fetch videos:", err);
        setLoading(false);
      });
  }, []);

  const handleUpgrade = async () => {
    try {
      const res = await axios.put(`${process.env.REACT_APP_API_URL}/api/user/account/upgrade`, {
        email: user.email,
        newPlan: "Pro",
      });
      setUser((prev) => ({ ...prev, plan: res.data.plan }));
      alert("🎉 Your plan has been upgraded to Pro!");
    } catch (err) {
      console.error("❌ Upgrade failed:", err);
      alert("Failed to upgrade plan");
    }
  };

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to logout?")) {
      localStorage.removeItem("paidUser");
      navigate("/");
      window.location.reload();
    }
  };

  return (
    <div className="paid-dashboard">
      {/* ✅ Top Navigation */}
      <nav className="top-nav">
        <div className="logo" onClick={() => navigate("/")}>NitinShukla</div>
        <div className="nav-actions">
          <button onClick={() => navigate("/user-dashboard")}>Dashboard</button>
          <button onClick={() => navigate("/profile")}>Profile</button>
          {user && (
            <button className="logout-btn" onClick={handleLogout}>
              Logout
            </button>
          )}
        </div>
      </nav>

      {/* ✅ User Info */}
      <header className="dashboard-header">
        <h2>Welcome, {user?.name || "User"}</h2>
        <p>Email: {user?.email || "-"}</p>
        <p>
          Current Plan: <strong>{user?.plan || "Basic"}</strong>
        </p>
        <button className="upgrade-btn" onClick={handleUpgrade}>
          Upgrade Plan
        </button>
      </header>

      {/* ✅ Videos Section */}
      <section className="all-videos">
        <h3>All Premium Videos</h3>
        {loading ? (
          <p>Loading videos...</p>
        ) : videos.length ? (
          <div className="video-grid">
            {[...videos]
              .sort((a, b) => b._id.localeCompare(a._id)) // Newest first based on _id
              .map((video) => (
                <div className="card3 mb-3" key={video._id}>
                  <div className="card-body">
                    <video width="100%" height="240" controls>
                      <source
                        src={
                          video.videoUrl
                            ? video.videoUrl.startsWith("http")
                              ? video.videoUrl
                              : `${process.env.REACT_APP_API_URL}${video.videoUrl.replace(/\\/g, "/")}`
                            : ""
                        }
                        type="video/mp4"
                      />
                    </video>
                    <h5>{video.title}</h5>
                    <p>{video.creator?.name || "Unknown"}</p>
                  </div>
                </div>
              ))}

          </div>
        ) : (
          <p>No videos found.</p>
        )}
      </section>
      <section class="footer-home">
        <h6>© 2025 Nitin Shukla. All rights reserved.</h6>
        
      </section>
    </div>
  );
};

export default PaidUserDashboard;
